module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_valge_est.037106da.svg";